import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';

import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CountToModule } from 'angular-count-to';

import { PagesRoutingModule } from './pages-routing.module';

import { LandingPageComponent } from './landing-page/landing-page.component';
import { MainServicesComponent } from './services-page/main-services.component';
import { ContactUsPageComponent } from './contact-us-page/contact-us.component';

@NgModule({
  declarations: [
    LandingPageComponent,
    MainServicesComponent,
    ContactUsPageComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    ScrollToModule.forRoot(),
    CarouselModule,
    CountToModule,
    NgbModule,
  ],
})
export class PagesModule {}
